<mat-card flex="100" *ngIf="pilot$ | async; let pilot">
  <mat-card-title class="float-left">
    {{ pilot.firstName }} {{ pilot.middleName }} {{ pilot.lastName }}
  </mat-card-title>
  <mat-card-subtitle>{{ airCarrier.abbreviation }} Pilot</mat-card-subtitle>
  <mat-divider></mat-divider>
  <mat-card-content>
    <fl-pilot-manage [pilot]="pilot"></fl-pilot-manage>
  </mat-card-content>
</mat-card>
